<template>
	<layout-login>
		<v-layout row wrap :style="companyBgUrl" class="background-size">
		<v-flex md5 ml-5>
		<div class="main-login" >
			<section class="login">
				<div class="login-logo">
					<h1 class="title-login">ACL</h1>
				</div>
				<p class="login-header">
					Bienvenido,<br>
					Gestiona tus usuarios, integra con terceros,<br>
					historial de accesos y más
				</p>
				<form class="login-inputs" id="login-form" @submit.prevent="signin">
					<div class="login-inputs-txt">
						<v-icon class="login-icon">perm_identity</v-icon>
						<div class="login-inputs-group">
							<input type="email"
								placeholder="Usuario"
								class="login-input"
								v-model="user"
								autocomplete="off"
								required>
						</div>
					</div>
					<hr class="login-spacer">
					<div class="login-inputs-txt">
						<v-icon class="login-icon">vpn_key</v-icon>
						<div class="login-inputs-group">
							<input type="password"
								placeholder="Contraseña"
								class="login-input"
								v-model="password"
								autocomplete="off"
								required>
						</div>
					</div>
				</form>
				<div class="login-footer">
					<p class="login-footer-pass">¿Olvidaste tu contraseña?</p>
					<v-btn type="submit"
						form="login-form"
						class="login-btn font-btn"
						color="success"
						:loading="isLoading"
						v-bind:class="{ disabled: isLoading }"
						accesskey="13"
						v-bind:disabled="isLoading"
						>
						Ingresar
					</v-btn>
					<!-- <v-btn
						@click="goTo('synchronize-companies-list')"
						class="login-btn font-btn w-btn"
						color="base"
						>
						Sincronización de compañías
					</v-btn> -->
				</div>
			</section>
		</div>
		</v-flex>
		</v-layout>
	</layout-login>
</template>

<script>

async function signin() {
	window.localStorage.clear();
	this.isLoading = true;
	const userData = {
		email: this.user,
		password: this.password,
		codeApp: process.env.APP_CODE,
		provider: 4,
	};
	try {
		const response = await this.$http.post('signin/auth', userData);
		const user = response.data.data;
		const inLocalStorage = JSON.stringify(user);
		const { token, codeProject } = user;
		localStorage.setItem(process.env.STORAGE_USER_KEY, inLocalStorage);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::codeProject`, codeProject);
		localStorage.setItem(`${process.env.STORAGE_USER_KEY}::token`, token);
		this.$store.dispatch('setToken', token);
		this.goTo('page-project');
	} finally {
		this.isLoading = false;
	}
}

function data() {
	return {
		companyBgUrl: `background-image: url(${process.env.COMPANY_LOGIN_BACKGROUND})`,
		user: '',
		password: '',
		isLoading: false,
	};
}

export default {
	name: 'page-login',
	data,
	methods: {
		signin,
	},
};
</script>

<style lang="scss" scoped>
.main-login {
	@include flex-around;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	height: 100vh;
	.login {
		text-align: center;
		width: 412px;
		.login-logo {
			margin-bottom: 32px;
		}
		.login-header {
			color: black;
			font-family: map-get($fonts,lato-light);
			font-size: map-get($sizes, medium22);
			margin: 0 auto 54px;
			width: 314px;
		}
		.login-inputs {
			font-size: 24px;
			margin-bottom: 90px;
			width: 100%;
			.login-inputs-txt {
				@include flex-between;
				.login-icon {
					color: #b2dd00;
				}
				.login-inputs-group {
					width: 90%;
					.login-input {
						@include txt-config(open-regular, medium16);
						color: black;
						height: 60px;
						outline: none;
						width: 100%;
					}
					.login-error-message {
						@include txt-config(open-regular, small);
						color: map-get($colors, red-error);
						float: left;
					}
				}
			}
			.login-spacer {
				border: 1px solid map-get($colors, subheaderText);
				opacity: 0.7;
				width: 100%;
			}
		}
		.login-footer {
			@include flex-around;
			.login-footer-pass {
				color: map-get($colors, base);
				font-family: map-get($fonts, open-regular);
				font-size: map-get($sizes, medium16);
			}
			.login-btn {
				@include btn(
					success,
					white,
					5px,
					30px,
					97px,
					auto,
					center,
					lato-regular,
					large
				);
				outline: none;
			}
			.login-btn:active {
				@include active-btn;
			}
			.disabled {
				@include btn(
					subheaderText,
					white,
					5px,
					30px,
					97px,
					auto,
					center,
					lato-regular,
					large
				);
			}
		}
	}
	.login-info {
		.login-info-text {
			color: white;
			font-family: map-get($fonts, lato-regular);
			font-size: map-get($sizes, medium18);
		}
		.login-info-btn {
			@include btn(
				blue-btn,
				white,
				5px,
				45px,
				127px,
				auto,
				center,
				lato-regular,
				large
			);
			cursor: pointer;
			display: block;
			text-decoration: none;
		}
		.login-info-btn:active {
			@include active-btn;
		}
	}
}

@keyframes autofill {
	to {
		color: white;
		background: transparent;
	}
}

input:-webkit-autofill {
	animation-name: autofill;
	animation-fill-mode: both;
	background-color: transparent !important;
}

.title-login {
	color: map-get($colors, base);
	font-family: map-get($fonts, open-semibold);
	font-size: 72px;
	font-style: italic;
}

.background-size {
	background-size: cover;
}

.font-btn {
	font-size: 10px !important;
}

.w-btn {
	width: 180px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/page-login.vue